import AXIOS from '@/axios-instance';

export default {

  createfile(fileName) {
    return AXIOS.post("/bpmn/file/" + fileName,
      {}
    );
  },
  uploadFile(formData) {
    return AXIOS.post("/bpmn/upload", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}